import { h } from 'preact'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsEvervaultEnabled } from '../../redux/selectors/evervault'
import { pageStateUpdate } from '../../redux/slice/pageStateSlice'
import ManualCardForm from './ManualCardForm'
import EvervaultCardForm from './EvervaultCardForm'
import EvervaultErrorBoundary from './EvervaultErrorBoundary'
import './styles.scss'

/**
 * Routing switch for card capture. Form priority is resolved in
 * `selectCardFormType`: Evervault > PCI iframe > default.
 *
 * - Evervault: rendered here, wrapped in an error boundary. If it crashes the
 *   boundary sets `pageState.isEvervaultFailed`, which moves the page to the
 *   next form type (PCI iframe when `isPciEnabled`, otherwise default).
 * - PCI: this component runs inside the PCI iframe and renders ManualCardForm.
 * - Default: ManualCardForm in the host page.
 */
const CardForm = props => {
  const dispatch = useDispatch()
  const isEvervaultEnabled = useSelector(selectIsEvervaultEnabled)

  if (isEvervaultEnabled) {
    return (
      <EvervaultErrorBoundary
        {...props}
        onError={() => dispatch(pageStateUpdate({ isEvervaultFailed: true }))}
      >
        <EvervaultCardForm {...props} />
      </EvervaultErrorBoundary>
    )
  }

  return <ManualCardForm {...props} />
}

CardForm.propTypes = {
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  setFocus: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  control: PropTypes.object.isRequired,
  trigger: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  canSaveCard: PropTypes.bool,
  shouldSaveCard: PropTypes.bool,
  theme: PropTypes.string,
}

export default CardForm
